// Clickini's - editorial video helper. Muted loops only; fetch + play when visible; respects reduced-motion and data-saver.
(function () {
  if (window.__ckVideoReady) return;
  window.__ckVideoReady = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  if (reduce || saveData || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (entry.isIntersecting && video.offsetParent !== null) {
        if (!video.getAttribute('src') && video.dataset.src) video.src = video.dataset.src;
        var played = video.play();
        if (played && played.catch) played.catch(function () {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.2 });

  function scan(root) {
    (root || document).querySelectorAll('video[data-ck-video]').forEach(function (video) { observer.observe(video); });
  }

  scan();
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
